<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Keyword</p>
        <button class="delete" @click="$emit('hide')"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="onSubmit">
          <div class="field">
            <label class="label">Keyword</label>
            <div class="control has-icons-right mt-2">
              <input
                type="text"
                :class="['input', { 'is-danger': error || error }]"
                v-model="newKeyword"
                name="keyword"
                maxlength="20"
                autofocus
              />
              <span class="icon is-small is-right" v-if="error || error"
                ><i class="fa fa-warning"></i
              ></span>
            </div>
            <p v-if="error || error" class="help is-danger">
              {{ error || error }}
            </p>
          </div>

          <div class="field is-pulled-left mt2">
            <div class="control">
              <button
                type="button"
                :class="[
                  'button',
                  'is-danger',
                  { 'is-loading': loadingDelete }
                ]"
                @click="onDelete"
              >
                Delete
              </button>
            </div>
          </div>

          <div class="field is-grouped is-pulled-right mt2">
            <div class="control">
              <button
                :class="[
                  'button',
                  'is-primary',
                  { 'is-loading': loadingUpdate }
                ]"
              >
                Update
              </button>
            </div>
            <div class="control">
              <a class="button" @click="$emit('hide')">Cancel</a>
            </div>
          </div>
        </form>
        <vue-toastr ref="toastr"></vue-toastr>
      </section>
    </div>
  </div>
</template>

<script>
import PracticesService from "@/services/PracticesService";

export default {
  name: "keyword-edit",

  props: ["keyword", "practiceId"],

  data() {
    return {
      newKeyword: this.keyword,
      error: "",
      loadingUpdate: false,
      loadingDelete: false
    };
  },

  methods: {
    onSubmit() {
      this.loadingUpdate = true;
      this.error = "";
      PracticesService.updateKeyword(
        this.practiceId,
        this.newKeyword,
        this.keyword
      )
        .then(() => {
          this.$refs.toastr.s("The keyword has been updated");
          this.loadingUpdate = false;
          setTimeout(() => {
            this.$emit("hide");
          }, 500);
        })
        .catch(error => {
          this.loadingUpdate = false;
          this.$refs.toastr.e(error);
          this.error = error;
        });
    },
    onDelete() {
      this.loadingDelete = true;
      PracticesService.deleteKeyword(this.practiceId, this.keyword)
        .then(() => {
          this.$refs.toastr.s("The keyword has been deleted");
          this.loadingDelete = false;
          setTimeout(() => {
            this.$emit("hide");
          }, 500);
        })
        .catch(() => {
          this.loadingDelete = false;
          this.$refs.toastr.e("There was a problem deleting this keyword");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
